import { API_LINKS } from "../constants/api";
import { UserInfo } from "../interfaces/authentication";
import { firmaLoginTekst } from "../lib/firmaLogin";

/**
 * Beskeden til en session, der ikke tilhører en person (se `erIkkePersonligSession`), på en side,
 * der kun giver mening for en person.
 *
 * Afløser "din profil er endnu ikke klar" for netop denne session: der er intet galt med profilen,
 * men sessionen er en virksomhed. Det eneste, medlemmet kan gøre, er at logge ind igen med sit
 * private MitID, så beskeden siger præcis det og linker til at logge ud (ADV-356).
 *
 * Som i `ProfilIkkeKlarBesked` står hele sætningen her, og kun konsekvensen skifter fra side til
 * side. `konsekvens` er sætningens begyndelse og fortsætter med ", når du er logget ind med dit
 * private MitID." Virksomhedens navn står med, så medlemmet kan se, hvad det er logget ind som —
 * se `firmaLoginTekst`, som forsiden deler.
 */
const IkkePersonligSessionBesked = ({
  identityType,
  navn,
  konsekvens,
}: {
  identityType?: UserInfo["identityType"];
  navn?: string | null;
  konsekvens: string;
}) => (
  <div className="alert alert-info mb-0" role="status">
    {identityType === "Company"
      ? firmaLoginTekst(navn)
      : "Du er ikke logget ind som privatperson."}{" "}
    {konsekvens}, når du er logget ind med dit private MitID.{" "}
    <a className="alert-link" href={API_LINKS.logout}>
      Log ud
    </a>
    , og log ind igen med dit private MitID.
  </div>
);

export default IkkePersonligSessionBesked;
